import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Loading from '../../../layout/Loading'
import SsoProxyService from '../../../service/SsoProxyService'
import GatewayType from '../../GatewayType'
import GatewayIssuerConfig from './GatewayIssuerConfig'
import GatewaySSOCertificates from './GatewaySSOCertificates'
import RewritingRules from './RewritingRules'
import SSOIDProviderConfiguration from './SSOIDProviderConfiguration'
import SSOSProviderConfiguration from './SSOSProviderConfiguration'

const SsoProxy: GatewayType = () => {
  const { t } = useTranslation()
  const [configurationStatus, setConfigurationStatus] = useState({} as any)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    SsoProxyService.getConfigurationStatus()
      .then((configurationStatus: any) => setConfigurationStatus(configurationStatus))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Loading isLoading={loading}>
      <Accordion defaultActiveKey='0'>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant='link' eventKey='0'>
              {t('ssoProxy.issuerConfig')}
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey='0'>
            <Card.Body>
              <GatewayIssuerConfig configurationStatus={configurationStatus} setConfigurationStatus={setConfigurationStatus} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        {configurationStatus !== undefined && configurationStatus.ssoHostNameSet === true && (
          <>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant='link' eventKey='1'>
                  {t('ssoProxy.ssoCertificates')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey='1'>
                <Card.Body>
                  <GatewaySSOCertificates />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant='link' eventKey='2'>
                  {t('ssoProxy.ssoIdpConfig')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey='2'>
                <Card.Body>
                  <SSOIDProviderConfiguration configurationStatus={configurationStatus} setConfigurationStatus={setConfigurationStatus} />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {configurationStatus !== undefined && configurationStatus.targetIdPMetadataAvailable === true && (
              <Card>
                <Card.Header>
                  <Accordion.Toggle as={Button} variant='link' eventKey='3'>
                    {t('ssoProxy.ssoSpConfig')}
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey='3'>
                  <Card.Body>
                    <SSOSProviderConfiguration configurationStatus={configurationStatus} setConfigurationStatus={setConfigurationStatus} />
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            <Card>
              <Card.Header>
                <Accordion.Toggle as={Button} variant='link' eventKey='4'>
                  {t('ssoProxy.rewritingRules')}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey='4'>
                <Card.Body>
                  <RewritingRules />
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </>
        )}
      </Accordion>
    </Loading>
  )
}

export default SsoProxy
